<template>
  <div class="main">
    <div class="form-container">
      <div class="login-text">Inizia con noi!</div>
      <div class="login">
        <div class="google-login">
          <Button class="google-button" @click="GoogleLogin">
            <span>Iscriviti con Google</span>
            <span>
              <GoogleIcon class="google-icon" />
            </span>

          </Button>
        </div>
        <div class="email-login">
          <span class="divider">
            <span class="line"></span>
            <span class="text">Oppure iscriviti con la tua mail</span>
            <span class="line"></span>
          </span>
          <input class="form-elements" type="text" id="Mail" v-model="Mail" placeholder="Inserisci la tua mail"
            required />
          <input class="form-elements" type="password" id="Password" v-model="Password"
            placeholder="Inserisci la password" required />
          <div class="sub-section">
            <label for="remember-me" class="checkbox-label">
              <input type="checkbox" id="remember-me" class="box-tick">
              <span>Ricordati di me</span>
            </label>
          </div>
          <Button class="login-button" @click="register">
            Registrati
          </Button>
        </div>
        <div class="subscribe">
          Hai già un account? <router-link class="link-sub" to="/login">Accedi!</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleIcon from '@/assets/Icons/SocialMedia/Google.vue';
import { supabase } from '@/lib/supabaseClient';
import { useAuthStore } from '@/stores/authStore';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'MainSignIn',
  components: {
    GoogleIcon
  },
  setup() {
    const Mail = ref("");
    const Password = ref("");
    const router = useRouter();
    const auth = useAuthStore();

    const register = async () => {
      await auth.register(Mail.value, Password.value);
      if (!auth.error) {
        console.log("Utente Registrato con successo!");

        const user = auth.user;
        if (user) {
          await addUserToSupabase(user.id, Mail.value);
        }

        router.push('/');
      } else {
        console.log(auth.error);
        alert(auth.error);
      }
    };

    const GoogleLogin = async () => {
      await auth.googleLogin();
      if (!auth.error) {
        console.log("Utente Registrato con successo con Google!");

        const user = auth.user;
        if (user) {
          await addUserToSupabase(user.id, user.email);
        }

        router.push('/');
      } else {
        console.log(auth.error);
        alert(auth.error);
      }
    };

    const addUserToSupabase = async (userId, email) => {
      try {
        const { data, error } = await supabase
          .from('users')
          .insert([{ user_id: userId, email: email, first_name: 'Studente', last_name: 'Studente' }]);

        if (error) throw error;
        console.log("User added to Supabase:", data);

        // Insert into user_account
        const { data: accountData, error: accountError } = await supabase
          .from('user_account')
          .insert([{
            user_id: userId,
            type_of_user: 'CONSULTANT',
            type_of_plan: 'STANDARD',
            created_at: new Date().toISOString()
          }]);

        if (accountError) throw accountError;
        console.log("User account created:", accountData);
      } catch (err) {
        console.error("Error adding user to Supabase:", err.message);
      }
    };

    return {
      Mail,
      Password,
      register,
      GoogleLogin,
      auth,
    };
  }
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #ffffff, #56BCEE);
  justify-content: center;
  align-items: center;
}

.form-container {
  background: rgba(255, 255, 255, 0.95);
  padding: 3rem;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.login-text {
  font-size: 2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 2rem;
  text-align: center;
}

.login {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.google-button {
  width: 100%;
  padding: 1rem;
  background: #ffffff;
  border: 2px solid #e0e0e0;
  border-radius: 0;
  font-size: 1rem;
  font-weight: 500;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  gap: 1rem;
  &:hover {
    background: #f8f8f8;
  }
}

.google-icon {
  width: 24px;
  height: 24px;
}

.divider {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #666;
  font-size: 0.9rem;
  margin: 1.5rem 0;

  .line {
    flex: 1;
    height: 1px;
    background: #e0e0e0;
  }
}

.form-elements {
  width: 100%;
  padding: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 0;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    border-color: #2e4eed;
    outline: none;
  }

  &::placeholder {
    color: #999;
  }
}

.sub-section {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin: 0.5rem 0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #666;
  cursor: pointer;

  .box-tick {
    width: 16px;
    height: 16px;
    accent-color: #2e4eed;
  }
}

.login-button {
  width: 100%;
  padding: 1rem;
  background: #2e4eed;
  color: #ffffff;
  border: none;
  border-radius: 0;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #1e3ed8;
  }
}

.subscribe {
  font-size: 0.9rem;
  color: #666;
  text-align: center;

  .link-sub {
    color: #2e4eed;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .form-container {
    padding: 2rem;
    margin: 1rem;
  }

  .login-text {
    font-size: 1.75rem;
  }
}
</style>